import React from 'react';

import { CardExpiryElement } from '@stripe/react-stripe-js';
import type { StripeCardExpiryElementChangeEvent } from '@stripe/stripe-js';

import { stripeElementDomId } from '#src/app/shared/utils/payments';

import { useHideAriaHiddenStripeInputsFromTabOrder } from '../../hooks';

type Props = {
	onChange?: (event: StripeCardExpiryElementChangeEvent) => unknown;
	onFocus?: () => void;
	onBlur?: () => void;
};

export const CardExpiryElementWrapper: React.FC<Props> = ({ onChange, onFocus, onBlur }) => {
	const containerRef = useHideAriaHiddenStripeInputsFromTabOrder();

	return (
		<div ref={containerRef}>
			<CardExpiryElement
				id={stripeElementDomId('cardExpiry')}
				options={{ style: { base: { fontSize: '16px' } } }}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
			/>
		</div>
	);
};
